/**
 * Minimum drag distance in pixels required to trigger drawer state changes
 * Used to differentiate between taps and intentional drags
 */
export const DRAG_THRESHOLD_PX = 50;

/**
 * Maximum drag distance in % of viewport height for minimized and open states
 */
export const MINIMIZED_DRAG_MAX = 40;
export const OPEN_DRAG_MAX = 70;

/**
 * Time in milliseconds to wait before considering a touch a drag rather than a tap
 */
export const TAP_DURATION_MS = 200;

/**
 * Drawer height values as percentage of viewport height
 * These determine the three possible positions of the drawer
 */
export const DRAWER_HEIGHTS = {
  OPEN: 100,
  MINIMIZED: '90px',
  CLOSED: 0
};

export const NR = {
  LOAD: 'MAA_LOADER_LOAD',
  OPEN: 'MAA_LOADER_OPEN',
  CLOSE: 'MAA_LOADER_CLOSE',
  LOADER_TIME: 'MAA_LOADER_TIME'
};